<template>
    <nav class="navbar navbar-expand-lg navbar-light" id="mainNav">
    <div class="container px-4 px-lg-5">
        <a class="navbar-brand" href="index.html"><img src="../assets/img.png"  class="img-fluid rounded-circle" width="50px" alt=""></a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavId" aria-controls="collapsibleNavId"
        aria-expanded="false" aria-label="Toggle navigation">
            <i class="fas fa-bars"></i>
        </button>
        <div class="collapse navbar-collapse" id="collapsibleNavId">
            <ul class="navbar-nav ms-auto py-4 py-lg-0">
                <li class="nav-item"><router-link class="nav-link px-lg-3 py-3 py-lg-4" to="/admin">Home</router-link></li>
                <li class="nav-item"><a class="nav-link px-lg-3 py-3 py-lg-4" href="about.html">Admin</a></li>
                <!-- <li class="nav-item"><button class="nav-link mt-2  btn btn-white">Print Form</button></li> -->

            </ul>
        </div>
    </div>
 </nav>
    <div class="container" style="margin-top:150px">
         <div class="row">
              <div class="card">
                  <div class="card-body">
                      <div class="card-text">
                          <div>
                              <img :src="info.image_url" class="rounded-circle img" alt="">
                          </div>
                      </div>
                      <div class="row mt-3">
                        <div class="col-md-12">
                           <div class="row">
                               <div class="col-md-6 mb-2">First Name: <strong> {{info.firstname}}</strong></div>
                               <div class="col-md-6 mb-3">Last Name: <strong> {{info.lastname}}</strong></div>
                               <div class="col-md-6 mb-2">Email: <strong> {{info.email}}</strong></div>
                               <div class="col-md-6 mb-3">StateOfOrigin: <strong> {{info.state}}</strong></div>
                               <div class="col-md-6 mb-3">L.G.A: <strong>{{info.local}}</strong></div>
                               <div class="col-md-6 mb-4">Phone: <strong> {{info.phone}}</strong></div>
                               <div class="col-md-6 mb-4">Status: <strong> {{info.status}}</strong></div>
                               <div class="col-md-6 mb-4">Parent_Name: <strong> {{info.parent_name}}</strong></div>
                               <div class="col-md-6 mb-4">Parent_Phone: <strong> {{info.parent_number}}</strong></div>
                               <div class="col-md-6 mb-4">NextOfKin: <strong> {{info.parent_name}}</strong></div>

                               <div class="col-md-6 mb-3"><strong>Click to Approve</strong> <button @click="approve" class="btn btn-secondary btn-edit">Approve</button></div>
                           </div>
                        </div>
                    </div>
                  </div>
              </div>
         </div>
    </div>
</template>

<script> 
import Axios from 'axios'
export default {
    data(){
        return{
            info:''

        }
    },
    methods:{
        approve(){
            //    this.$router.reload()
          let id =  this.$route.params.id
          console.log(id)
          const URL ="https://stormy-ravine-66505.herokuapp.com/api/upd"
          Axios.patch(URL, {id:id}).then(res=>{
              console.log(res)
              if(res.status == 200){
                  this.$swal.fire({
                       icon: 'success',
                        title: 'Good',
                       text: res.data.message,
                       preConfirm:()=>{
                         window.location.reload();
                       }
                  })
              }
          }).catch(err => console.log(err))
          
        },
        getDetails(){
            let id = this.$route.params.id
            const URL = `https://stormy-ravine-66505.herokuapp.com/api/user_profile/${id}`
            Axios.get(URL).then(res=>{
                this.info = res.data.response
                console.log(this.info)
            }).catch(err => console.log(err))
        }
    },
    created(){
        this.getDetails()
    },
}
</script>

<style lang="css" scoped>
    .img{
        width: 200px;
    }
     #mainNav {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        z-index: 1030;
        border-bottom: 1px solid #5a5a5a;
        background-color: rgb(121, 121, 121) !important;
        font-family: "Open Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
      }
      #mainNav .navbar-brand {
        font-weight: 800;
      }
      #mainNav .navbar-toggler {
        font-size: 0.75rem;
        font-weight: 800;
        padding: 0.75rem;
        text-transform: uppercase;
      }
      #mainNav .navbar-nav > li.nav-item > a.nav-link {
        font-size: 0.75rem;
        font-weight: 800;
        letter-spacing: 0.0625em;
        text-transform: uppercase;
      }
      @media (min-width: 992px) {
        #mainNav {
          border-bottom: 1px solid transparent;
          background: transparent;
        }
        #mainNav .navbar-brand {
          color: #fff;
        }
        #mainNav .navbar-brand:focus, #mainNav .navbar-brand:hover {
          color: rgba(255, 255, 255, 0.8);
        }
        #mainNav .navbar-nav > li.nav-item > a.nav-link {
          color: #fff;
        }
        #mainNav .navbar-nav > li.nav-item > a.nav-link:focus, #mainNav .navbar-nav > li.nav-item > a.nav-link:hover {
          color: rgba(255, 255, 255, 0.8);
        }
      }
      @media (min-width: 992px) {
        #mainNav {
          transition: background-color 0.2s;
          /* Force Hardware Acceleration in WebKit */
          transform: translate3d(0, 0, 0);
          -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
        }
        #mainNav.is-fixed {
          /* when the user scrolls down, we hide the header right above the viewport */
          position: fixed;
          top: -83px;
          transition: transform 0.2s;
          border-bottom: 1px solid white;
          background-color: rgba(255, 255, 255, 0.9);
        }
        #mainNav.is-fixed .navbar-brand {
          color: #212529;
        }
        #mainNav.is-fixed .navbar-brand:focus, #mainNav.is-fixed .navbar-brand:hover {
          color: #0085A1;
        }
        #mainNav.is-fixed .navbar-nav > li.nav-item > a {
          color: #212529;
        }
        #mainNav.is-fixed .navbar-nav > li.nav-item > a:focus, #mainNav.is-fixed .navbar-nav > li.nav-item > a:hover {
          color: #0085A1;
        }
        #mainNav.is-visible {
          /* if the user changes the scrolling direction, we show the header */
          transform: translate3d(0, 100%, 0);
        }
      }
</style>